<script>
    import CancelLabelButton from '@/src/components/CancelLabelButton.vue'

    export default {
        name: 'NoDataExportModal',
        components: {
            CancelLabelButton
        },
        props: {
            handleClose: {
                type: Function,
                required: false,
                default: null,
            }
        },
        data() {
            return {
                handleConfirm: null,
            }
        },
        computed: {
            i18nNoFilterExportModal() {
                return this.getI18n('PAGINATION', 'no_data_export')
            },
            i18nTitleModal() {
                return this.getI18n('COMMON', 'attention')
            },
        },
        methods: {
            showModal() {
                this.$refs.noDataExportModal.show()
            },
            close() {
                if (this.handleClose) {
                    this.$props.handleClose()
                }
                else {
                    this.hide()
                }
            },
            handleCancel() {
                this.$refs.noDataExportModal.hide();
            },
        }
    }
</script>

<template>
    <div>
        <b-modal
            id="no-data-export-modal"
            ref="noDataExportModal"
            centered
            :no-close-on-backdrop="true"
            :no-enforce-focus="true"
            size="md"
        >
            <template v-slot:modal-header>
                <h4 class="modal-title description">
                    {{ i18nTitleModal }}
                </h4>
                <button class="close" @click="handleCancel">
                    <i class="fe-x-circle icon-blue"/>
                </button>
            </template>
            <b-row class="modal-body text-center message">
                {{ i18nNoFilterExportModal }}
            </b-row>
            <template v-slot:modal-footer>
                <div class="col text-center ml-3 mr-3">
                    <cancel-label-button
                        @onClick="handleCancel"
                    />
                </div>
            </template>
        </b-modal>
    </div>
</template>
